import { Directive, ElementRef, Input, OnInit, AfterViewInit } from '@angular/core';
import { AppLocalizationService } from '@app/shared/common/localization/app-localization.service';

@Directive({
    selector: '[buttonBusy]',
})
export class ButtonBusyDirective implements OnInit, AfterViewInit {
    @Input() busyText: string;
    private _originalButtonInnerHtml: any;
    private _originalButtonDisabledAttribute: any;
    private _button: any;

    constructor(private _element: ElementRef, private _appLocalizationService: AppLocalizationService) {}

    @Input() set buttonBusy(isBusy: boolean) {
        this.refreshState(isBusy);
    }

    ngOnInit(): void {
        this._button = this._element.nativeElement;
    }

    ngAfterViewInit(): void {
        this._originalButtonInnerHtml = this._button.innerHTML;
    }

    refreshState(isBusy: boolean): void {
        if (!this._button) {
            return;
        }

        if (isBusy) {
            // disable button
            this._originalButtonDisabledAttribute = this._button.getAttribute('disabled');
            this._button.setAttribute('disabled', 'disabled');

            this._button.innerHTML =
                '<i class="fa fa-spinner fa-spin" style="width: 1em; height: 1em; text-align: center; vertical-align: middle; transform-origin: center center; display: inline-block;"></i>' +
                '<span style="margin-left: 0.5rem;">' +
                (this.busyText ? this.busyText : this._appLocalizationService.l('ProcessingWithThreeDot')) +
                '</span>';

            this._button.setAttribute('_disabledBefore', true);
        } else {
            if (!this._button.getAttribute('_disabledBefore')) {
                return;
            }

            // Wiederherstellen: entferne das Attribut nur, wenn es vorher nicht gesetzt war
            if (this._originalButtonDisabledAttribute) {
                this._button.setAttribute('disabled', 'disabled');
            } else {
                this._button.removeAttribute('disabled');
            }

            this._button.innerHTML = this._originalButtonInnerHtml;
        }
    }
}
